var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 42,
    viewBox: "0 0 25 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.8271 0.75H5.45241C2.85534 0.75 0.75 2.85534 0.75 5.45241V36.0476C0.75 38.6447 2.85534 40.75 5.45241 40.75H18.8271C21.4242 40.75 23.5295 38.6447 23.5295 36.0476V5.45241C23.5295 2.85534 21.4242 0.75 18.8271 0.75Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.07275 17.105C7.75889 17.105 8.31569 17.6611 8.31592 18.3472C8.31592 19.0334 7.75903 19.5903 7.07275 19.5903C6.38667 19.5901 5.83057 19.0333 5.83057 18.3472C5.8308 17.6612 6.38682 17.1052 7.07275 17.105Z",
    fill: "white",
    stroke: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1394 17.105C12.8255 17.105 13.3823 17.6611 13.3826 18.3472C13.3826 19.0334 12.8257 19.5903 12.1394 19.5903C11.4533 19.5901 10.8972 19.0333 10.8972 18.3472C10.8974 17.6612 11.4535 17.1052 12.1394 17.105Z",
    fill: "white",
    stroke: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2051 17.105C17.8912 17.105 18.448 17.6611 18.4482 18.3472C18.4482 19.0334 17.8914 19.5903 17.2051 19.5903C16.519 19.5901 15.9629 19.0333 15.9629 18.3472C15.9631 17.6612 16.5191 17.1052 17.2051 17.105Z",
    fill: "white",
    stroke: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.07275 24.5698C7.75889 24.5698 8.31569 25.1259 8.31592 25.812C8.31592 26.4983 7.75903 27.0552 7.07275 27.0552C6.38667 27.0549 5.83057 26.4981 5.83057 25.812C5.8308 25.1261 6.38682 24.5701 7.07275 24.5698Z",
    fill: "white",
    stroke: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1394 24.5698C12.8255 24.5698 13.3823 25.1259 13.3826 25.812C13.3826 26.4983 12.8257 27.0552 12.1394 27.0552C11.4533 27.0549 10.8972 26.4981 10.8972 25.812C10.8974 25.1261 11.4535 24.5701 12.1394 24.5698Z",
    fill: "white",
    stroke: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2051 24.5698C17.8912 24.5698 18.448 25.1259 18.4482 25.812C18.4482 26.4983 17.8914 27.0552 17.2051 27.0552C16.519 27.0549 15.9629 26.4981 15.9629 25.812C15.9631 25.1261 16.5191 24.5701 17.2051 24.5698Z",
    fill: "white",
    stroke: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1394 32.2441C12.8255 32.2441 13.3823 32.8002 13.3826 33.4863C13.3826 34.1726 12.8257 34.7295 12.1394 34.7295C11.4533 34.7293 10.8972 34.1725 10.8972 33.4863C10.8974 32.8004 11.4535 32.2444 12.1394 32.2441Z",
    fill: "white",
    stroke: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1726 4.98828H14.6801",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileIcon);
export default __webpack_public_path__ + "static/media/mobile-icon.deedce056e352c863904440d90ed6cb3.svg";
export { ForwardRef as ReactComponent };